<template>
    <div :id="id" class="title-content">
        <div class="line"></div>
        <div>{{ title }}</div>
    </div>
</template>

<script>
export default {
    name: "custom-title",
    props: {
        // 标题内容
        title: String,
        // 节点标识
        id:String,
    }
}
</script>

<style scoped lang="scss">
.title-content {
    display: flex;
    align-items: center;
    padding-right: 26px;
    font-size: $titleSize;
    font-weight: 600;
    .line {
        width: 8px;
        height: 40px;
        background: $defaultGreen;
        margin-right: 18px;
    }
}
</style>
